import { render, staticRenderFns } from "./accountProfile.vue?vue&type=template&id=1860c3b9&scoped=true&"
import script from "./accountProfile.vue?vue&type=script&lang=js&"
export * from "./accountProfile.vue?vue&type=script&lang=js&"
import style0 from "./accountProfile.vue?vue&type=style&index=0&id=1860c3b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860c3b9",
  null
  
)

export default component.exports